import React, { JSX } from 'react';
import { Text, RichText, Field } from '@sitecore-jss/sitecore-jss-nextjs';
import { classNames } from 'assets/utils/helper';
import { getMarginSize } from 'assets/utils/getMarginSize';
import { StyleguideComponentProps } from 'lib/component-props';

type SplitContentCalloutProps = StyleguideComponentProps & {
  fields: {
    MarginSize: {
      fields: {
        heading: {
          value: string;
        };
      };
    };
    BaseHeadline: Field<string>;
    BaseLeftContent: Field<string>;
    BaseRightContent: Field<string>;
  };
};

const SplitContentCallout = (props: SplitContentCalloutProps): JSX.Element => {
  if (!props || !props.fields) {
    return <div></div>;
  }

  const marginSize = getMarginSize(
    props?.fields?.MarginSize?.fields?.heading?.value
  );

  return (
    <div
      className={classNames('overhauled', marginSize)}
      id={`split-content-callout-${props.rendering?.uid}`}
    >
      <div className="split-content-callout">
        <div className="jss-inner-container">
          <div className="content-wrapper bg-primary">
            <div className="border-accent gradient-vertical"></div>
            <div className="inner-content inner-side-spacing inner-vertical-spacing">
              <div className="text-content">
                {props.fields?.BaseLeftContent?.value && (
                  <div className="left-content">
                    {props.fields?.BaseHeadline?.value && (
                      <Text
                        tag="h2"
                        className="osf-display-h2 headline"
                        field={props.fields?.BaseHeadline}
                      />
                    )}
                    <RichText
                      tag="div"
                      className="osf-body-copy left-description"
                      field={props.fields?.BaseLeftContent}
                    />
                  </div>
                )}
                {props.fields?.BaseRightContent?.value && (
                  <RichText
                    tag="div"
                    className="osf-body-copy right-content"
                    field={props.fields?.BaseRightContent}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SplitContentCallout;
